import React, { useState, useEffect } from "react";
import '../../index.css';

const initialUser = [
  { id: 1, name: "User 1", role: "Admin", status: "Active" },
  { id: 2, name: "User 2", role: "Admin", status: "Inactive" },
  { id: 3, name: "User 3", role: "Accountant", status: "Active" },
];

export default function User() {

  const STORAGE_KEY = "User";
  const [UserList, setUserList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [formData, setFormData] = useState({
    id: "",
    name: "",
    role: "",
    status: "Active"
  });

  // 🔍 FILTER
  const filteredUser = UserList.filter((c) =>
    c.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    c.role.toLowerCase().includes(searchTerm.toLowerCase()) ||
    c.status.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // ADD
  const openAddModal = () => {
    setIsEdit(false);
    setFormData({
      id: "",
      name: "",
      role: "",
      status: "Active"
    });
    setShowModal(true);
  };

  // UPDATE
  const openEditModal = () => {
    if (!selectedUser) {
      alert("Select a User first");
      return;
    }
    setIsEdit(true);
    setFormData(selectedUser);
    setShowModal(true);
  };

  // DELETE
  const handleDelete = () => {
    if (!selectedUser) {
      alert("Select a User first");
      return;
    }

    const updated = UserList.filter(
      (c) => c.id !== selectedUser.id
    );

    setUserList(updated);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    window.dispatchEvent(new Event("storage"));

    setSelectedUser(null);
  };

  // SAVE
  const handleSave = () => {

    if (!formData.name || !formData.role) {
      alert("All fields required");
      return;
    }

    let updatedList = [];

    if (isEdit) {
      updatedList = UserList.map((c) =>
        c.id === formData.id ? formData : c
      );
    } else {
      const newUser = {
        ...formData,
        id: Date.now(),
      };

      updatedList = [newUser, ...UserList];
    }

    setUserList(updatedList);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedList));
    window.dispatchEvent(new Event("storage"));

    setShowModal(false);
    setSelectedUser(null);
  };

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

    if (saved.length === 0) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(initialUser));
      setUserList(initialUser);
    } else {
      setUserList(saved);
    }
  }, []);

  useEffect(() => {
    const handleStorage = () => {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      setUserList(saved);
    };

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  return (
    <>
      <style>{`
        .page { background:#f5f7fb; padding:20px; }
        .card { background:#fff; padding:15px; border-radius:8px; }

        .header { display:flex; justify-content:space-between; margin-bottom:10px; }

        .controls { display:flex; gap:10px; margin-bottom:10px; flex-wrap:wrap; }

        .search-box {
          padding: 8px;
          border: 1px solid #ccc;
          border-radius: 4px;
        }

        .btn { padding:7px 12px; border:none; border-radius:4px; cursor:pointer; }
        .btn-dark { background:#2c3e50; color:white; }
        .btn-blue { background:#3498db; color:white; }
        .btn-red { background:#e74c3c; color:white; }

        table { width:100%; border-collapse:collapse; }
        th, td { padding:10px; border-bottom:1px solid #eee; }

        tr:hover { background:#f4f6f9; cursor:pointer; }
        .active-row { background:#eef3ff; }

        .status { color:green; }

        input[type="checkbox"] {
          cursor:pointer;
        }

        .modal {
          position:fixed;
          top:0;
          left:0;
          width:100%;
          height:100%;
          background:rgba(0,0,0,0.5);
          display:flex;
          justify-content:center;
          align-items:center;
        }

        .modal-content {
          background:white;
          padding:20px;
          border-radius:8px;
          width:350px;
        }

        .modal-content input,
        .modal-content select {
          width:100%;
          margin-bottom:10px;
          padding:8px;
        }
      `}</style>

      <div className="page">
        <div className="card">

          {/* HEADER */}
          <div className="header">
            <h3>User</h3>
            <div>{UserList.length} Records</div>
          </div>

          {/* CONTROLS */}
          <div className="controls">

            <input
              className="search-box"
              placeholder="Search user..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            <button className="btn btn-dark" onClick={openAddModal}>
              + Add User
            </button>

            <button className="btn btn-blue" onClick={openEditModal}>
              Update
            </button>

            <button className="btn btn-red" onClick={handleDelete}>
              Delete
            </button>
          </div>

          {/* TABLE */}
          <table>
            <thead>
              <tr>
                <th></th>
                <th>User Name</th>
                <th>Role</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {filteredUser.map((c) => (
                <tr
                  key={c.id}
                  className={selectedUser?.id === c.id ? "active-row" : ""}
                  onClick={() =>
                    setSelectedUser(
                      selectedUser?.id === c.id ? null : c
                    )
                  }
                >
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedUser?.id === c.id}
                      onChange={() =>
                        setSelectedUser(
                          selectedUser?.id === c.id ? null : c
                        )
                      }
                      onClick={(e) => e.stopPropagation()}
                    />
                  </td>

                  <td>{c.name}</td>
                  <td>{c.role}</td>
                  <td className="status">{c.status}</td>
                </tr>
              ))}
            </tbody>
          </table>

        </div>

        {/* MODAL */}
        {showModal && (
          <div className="modal">
            <div className="modal-content">

              <h3>{isEdit ? "Update User" : "Add User"}</h3>

              <input
                placeholder="User Name"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
              />

              <select
                value={formData.role}
                onChange={(e) =>
                  setFormData({ ...formData, role: e.target.value })
                }
              >
                <option value="Select">Select</option>
                <option value="Teacher">Teacher</option>
                <option value="Student">Student</option>
                <option value="Admin">Admin</option>
                <option value="Accountant">Accountant</option>
                <option value="Employee">Employee</option>
              </select>

              <select
                value={formData.status}
                onChange={(e) =>
                  setFormData({ ...formData, status: e.target.value })
                }
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>

              <div style={{ display: "flex", gap: "10px" }}>
                <button className="btn btn-blue" onClick={handleSave}>
                  Save
                </button>

                <button
                  className="btn btn-red"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
              </div>

            </div>
          </div>
        )}

      </div>
    </>
  );
}